export const stackTypes = {
  pro: 'Pro', con: 'Con', second: 'Second', question: 'Call the Question',
  order: 'Point of Order', information: 'Point of Information',
  other: 'Other'
}